// Fixed-position hex-grid background layer. Mounted by v2 page wrappers
// behind the main content so the body shows the neon hex pattern with a
// soft radial mask towards the edges.
export function V2HexBackground() {
  return <div aria-hidden className="v2-hex-bg" />;
}
